import { createTranslator } from "next-intl";
import messages from "./messages/en.json";

// Local messages also support standalone profile cards and Storybook previews.
export const talentNetworkText = createTranslator({
  locale: "en",
  messages: messages.talentNetworkUi,
});
